import React from "react";
import PropTypes from "prop-types";

import StatsCard from "../statsCard/statsCard";

const StatsRow = ({ metrics }) => (
  <div className="operator-dashboard-stats-row">
    {metrics.map((metric) => (
      <StatsCard
        key={metric.id}
        label={metric.label}
        value={metric.value}
        trend={metric.trend}
        trendDirection={metric.trendDirection}
        showMenu={metric.showMenu}
      />
    ))}
  </div>
);

StatsRow.propTypes = {
  metrics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      trend: PropTypes.string.isRequired,
      trendDirection: PropTypes.oneOf(["up", "down"]).isRequired,
      showMenu: PropTypes.bool,
    })
  ).isRequired,
};

export default StatsRow;
